/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Settlement_Method_RequiredInputs */

const vi_order_settlement_method_required = /** @type {(inputs: Order_Settlement_Method_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn khách trả tiền mặt, chuyển khoản hay ghi nợ rồi mới xác nhận giao`)
};

/**

* @param {Order_Settlement_Method_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_settlement_method_required = /** @type {((inputs?: Order_Settlement_Method_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Settlement_Method_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_settlement_method_required(inputs)
});